import {
    Avatar, Button,
    Clickable, Col, Divider, Icon, Row, Sidepanel, Text
} from 'components';
import { Api, capitalize, theme } from 'lib';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IrreversableModal } from 'screens/Admin/components';
import styled from 'styled-components';

const ImageContainer = styled.div`
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 100%;
`;

const irreversableModalHeading = `
    This user haven't posted an image with ID yet. Are you sure want to verify this user?
  `;

const irreversableModalText = `
    This action will also verify this user's email. This action is irreversable.
  `;

const Verify = ({ user = {}, visible, closeModal }) => {
  const [loading, setLoading] = useState(false),
    [irreverseVisible, setIrriverseVisible] = useState(false),
    dispatch = useDispatch(),
    isAthlete = user?.type === 'athlete',
    team = isAthlete && user.sports?.length && user.sports[0].team,
    hasImage = user?.verified?.idImage;

  /*
    Handles both verify/unverify user
  */
  async function submit(status, fromModal) {
    if (!fromModal && !hasImage) return setIrriverseVisible(true);

    setLoading(true);

    const res = await Api.post(
      '/admin/verifyUser',
      { status, userId: user._id },
      status === 'verified' ? 'unverifyUser' : 'verifyUser'
    );
    if (!res) return setLoading(false);

    dispatch({
      type: 'ADMIN_VERIFY_USER',
      payload: { status, userId: user._id }
    });

    setLoading(false);

    closeModal();
  }

  return (
    <Sidepanel wid={600} pad="24px 0" visible={visible} closeModal={closeModal}>
      <Col wid="100%" ht="calc(100% - 24px)" pos="relative">
        <Row pad="0 24px 24px" wid="calc(100% - 48px)" start>
          <Col center>
            <Clickable onClick={closeModal}>
              <Icon type="arrowLeft" dimensions={20} marg="0 12px 0 0" />
            </Clickable>
          </Col>

          <Avatar user={user} small wid="100%" />

          <Row between wid="100%">
            <Col marg="0 0 0 10px">
              <Text med>{user.name}</Text>
              <Text c1 med>
                @{user.username}
              </Text>
            </Col>

            <Col noFlex between>
              <Text med c1 right>
                {capitalize(user?.type)}
              </Text>

              {team && (
                <Row center>
                  <Text b2 marg="0 5px 0 0">
                    Requested association with team:
                  </Text>

                  <Text med b2>
                    {user.sports[0].teamName}
                  </Text>
                </Row>
              )}
            </Col>
          </Row>
        </Row>

        <Divider />

        <Col centerAll wid="inherit" marg="24px 0 0">
          {hasImage ? <ImageContainer src={hasImage} /> : <Icon type="noPhotos" dimensions="40" />}
        </Col>

        {user.verified?.id ? (
          <Col noFlex pad="24px" centerAll wid="100%">
            <Text h4>User is verified</Text>
          </Col>
        ) : (
          <Row pad="24px">
            <Button
              text="Don't verify"
              onClick={() => submit('notVerified')}
              bordered
              big
              wid="200px"
              marg="0 24px 0 0"
              disabled={!hasImage || loading}
              action="unverifyUser"
            />

            <Button
              text="Verify user"
              onClick={() => submit('verified')}
              big
              wid="200px"
              bg={theme.SECONDARY}
              disabled={loading}
              action="verifyUser"
            />
          </Row>
        )}
      </Col>

      <IrreversableModal
        heading={irreversableModalHeading}
        text={irreversableModalText}
        visible={irreverseVisible}
        closeModal={() => setIrriverseVisible(false)}
        confirmText="Verify user"
        onConfirm={() => submit('verified', true)}
      />
    </Sidepanel>
  );
};

export default Verify;
